@if (loaderVisible()) {
  <div
    class="page-loader"
    [class.is-leaving]="loaderLeaving()"
    role="status"
    aria-live="polite"
    [attr.aria-label]="loaderStatus()"
  >
    <div class="page-loader__content">
      <div class="page-loader__mark" aria-hidden="true">
        <img src="assets/img/logos/logo-white.svg" alt="" width="184" height="40" />
      </div>
      <p>{{ loaderStatus() }}</p>
      <div class="page-loader__progress" aria-hidden="true"><span></span></div>
      <small>Strategy&nbsp;&nbsp;•&nbsp;&nbsp;Engineering&nbsp;&nbsp;•&nbsp;&nbsp;AI</small>
    </div>
  </div>
}

<div class="app-stage" [class.is-loading]="loaderVisible()">
  <router-outlet></router-outlet>
  <app-whatsapp-button></app-whatsapp-button>
</div>
